class QuoterFilter {
    static filterResults(filterObject, quotes) {
        const normalizedQuotes = Array.isArray(quotes) ? quotes : (quotes ? [quotes] : []);
        if (!filterObject) { return normalizedQuotes; }
        let results = [...normalizedQuotes];
        if (filterObject.noMedicalExamOnly) { results = results.filter(x => x.requiresMedicalExam.toLowerCase() === 'no'); }
        if (filterObject.medicalExamOnly) { results = results.filter(x => x.requiresMedicalExam.toLowerCase() !== 'no'); }
        if (filterObject.digitalOnly) { results = results.filter(x => (x.isDigitalProduct === true && x.requiresPhoneInterview === false)); }
        if (filterObject.phoneOnly) { results = results.filter(x => (x.isDigitalProduct === false && x.requiresPhoneInterview === true)); }
        if (filterObject.convertibleOnly) { results = results.filter(x => x.hasConvertibility === true); }
        if (filterObject.notConvertibleOnly) { results = results.filter(x => x.hasConvertibility !== true); }
        if (filterObject.levelTerm) { results = results.filter(x => x.isDecreasingTerm !== true); }
        if (filterObject.decreasingTerm) { results = results.filter(x => x.isDecreasingTerm === true); }
        return results;
    };
};

const DEFAULT_FILTER_OBJECT = {
    noMedicalExamOnly: false,
    medicalExamOnly: false,
    digitalOnly: false,
    phoneOnly: false,
    convertibleOnly: false,
    notConvertibleOnly: false,
    levelTerm: false,
    decreasingTerm: false,
};

export const getSavedFiltersForCurrentFlow = (termSettings, isSimplifiedIssueTerm) => {
    if (!termSettings || termSettings.filters === null || termSettings.filters === undefined) {
        return null;
    }

    const savedFilterForSimplifiedIssueTerm = termSettings.isSimplifiedIssueTerm === true;
    return (savedFilterForSimplifiedIssueTerm === isSimplifiedIssueTerm) ? termSettings.filters : null;
};

export const getInitialFilterObject = (savedFilters, filterState) => {
    const normalizedFilterStateArray = typeof filterState === 'string' ? filterState.split(',').map(item => item.trim().toLowerCase()) : [];

    // store all matched filter keys in preFilteredObject with true value and return the preFilteredObject, if no keys are matched return the savedFilters or null
    const preFilteredObject = Object.keys(DEFAULT_FILTER_OBJECT)
        .filter(key => normalizedFilterStateArray.includes(key.toLowerCase()))
        .map(key => [key, true]);

    if (savedFilters !== null && savedFilters !== undefined) {
        return savedFilters;
    }

    return preFilteredObject.length > 0
        ? { ...DEFAULT_FILTER_OBJECT, ...Object.fromEntries(preFilteredObject) }
        : null;
};
export default QuoterFilter;
